import { FC, memo } from "react";
import { MatchStatus } from "service";
import { BallBase } from "components/common/BallBase";
import FootballBall from "../assets/Ball.svg";

const NO_BALL_EVENTS: string[] = [
  "1005",
  "1006",
  "1003",
  "1030",
  "1031",
  "1032",
  "1033",
  "1034",
  "1035",
  "1036",
  "1011",
  "1012",
];
const PATH_STOPPER_EVENTS: string[] = [
  ...NO_BALL_EVENTS,
  "1010",
  "1009",
  "1024",
  "1007",
  "1234",
  "1003",
];

const VIEW_W = 400;
const VIEW_H = 180;

export const Ball: FC<{ status: MatchStatus }> = memo(({ status }) => {
  const extraDeps = [(status as any)?.sc, status.x, status.y];

  return (
    <BallBase
      status={status}
      ballImageHref={FootballBall}
      viewW={VIEW_W}
      viewH={VIEW_H}
      ballSize={12}
      pathLineMax={5}
      pathStopperEvents={PATH_STOPPER_EVENTS}
      showShadowEllipse={true}
      extraPathDeps={extraDeps}
      smoothMs={450}
    />
  );
});
